import DragFileIcon from '../../assets/icons/DragFileIcon.svg?react';
import UpArrowIcon from '../../assets/icons/UpArrowIcon.svg?react';
import DownArrowIcon from '../../assets/icons/DownArrowIcon.svg?react';
import MoveIcon from '../../assets/icons/MoveIcon.svg?react';
import useSortFile from '../../hooks/useSortFile';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import XButton from '../common/XButton';

const rowBaseClasses =
    'flex items-center justify-between gap-2 bg-white border border-border rounded-md px-3 py-2 mb-2';
const rowRecentClasses = 'bg-primary-surface!';
const leftClasses = 'flex items-center';
const actionsClasses = 'flex items-center gap-2 shrink-0';

const SortFile = ({ id, entry, onMoveUp, onMoveDown, isFirst, isLast, orderIndex, isRecentlyMoved }) => {
    const { handleMoveDown, handleMoveUp } = useSortFile({ id, isRecentlyMoved, isFirst, isLast, onMoveUp, onMoveDown });
    const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id });

    return (
        <div
            ref={setNodeRef}
            style={{
                transform: CSS.Transform.toString(transform),
                transition,
            }}
            {...attributes}
            {...listeners}
            className={`${rowBaseClasses} ${isRecentlyMoved ? rowRecentClasses : ''}`}
        >
            <div className={leftClasses}>
                <span className="mr-2!">
                    <DragFileIcon />
                </span>
                <MoveIcon size={18} className="mr-2!" />
                <span className="mr-2! text-body">{orderIndex + 1}.</span>
                {entry}
            </div>
            <div className={actionsClasses}>
                <XButton
                    variant="link"
                    onClick={handleMoveDown}
                    onPointerDown={(event) => event.stopPropagation()}
                    disabled={isLast}
                    aria-label="Move file down"
                >
                    <DownArrowIcon />
                </XButton>
                <XButton
                    variant="link"
                    onClick={handleMoveUp}
                    onPointerDown={(event) => event.stopPropagation()}
                    disabled={isFirst}
                    aria-label="Move file up"
                >
                    <UpArrowIcon />
                </XButton>
            </div>
        </div>
    );
};

export default SortFile;
